import aproDetailsLocale from './en.json'

const en = {
  aproDetails: aproDetailsLocale,
}

export default en
